var AdminMainController = (function () {
    function AdminMainController(env, $filter, DTS, $stateParams, $state, socket, $scope, admin, opptyCount, countLoaded) {
        var _this = this;
        if (countLoaded === void 0) { countLoaded = false; }
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.admin = admin;
        this.opptyCount = opptyCount;
        this.countLoaded = countLoaded;
        this.table = { sortType: '', sortReverse: false, search: '', filter: false, filterParams: {} };
        this.options = { oneSelected: false, selected: {} };
        this.countFired = false;
        this.table.headers = ['Profile', 'Description'];
        this.table.profiles = [
            { profile: 'admin.status-view', name: 'Status Configuration', desc: 'Profile for all Main and Sub-Statuses', enabled: true },
            { profile: 'admin.mysaresponse-view', name: 'MySA Response', desc: 'MySA Response - List of Check Results', enabled: true },
            { profile: 'admin.bpmergers-view', name: 'BP Mergers', desc: 'BP Mergers table', enabled: true },
            {
                profile: 'admin.program-view', name: 'Program Workflows',
                desc: 'Profiles for each unique combination of Country, Program, Brand and BP Type', enabled: true
            },
            { profile: 'admin.misc-codes-view', name: 'Miscellaneous Codes', desc: 'Profiles for all Codes used in DMT whether that\'s payment or rejection codes, or dispute codes', enabled: true },
            // { profile: 'admin.gbt20-view', name: 'GBT20 Batch Log', desc: 'Log for the daily GBT20 batch from ODS', enabled: true },
            { profile: 'admin.mysa-dmt-view', name: 'MySA Opportunity Logs', desc: 'Interface for querying opportunity transfers to and from MySA', enabled: true },
            { profile: 'admin.mysa-im-outbound-view', name: 'MySA IM Opportunity Logs', desc: 'Interface for querying opportunity transfers to MySA IM', enabled: true },
            { profile: 'admin.gppload-view', name: 'GPP Status Update Log', desc: 'Log for the daily submission of GPP statuses for Closed, Rejected and Paid items', enabled: true },
            { profile: 'admin.bptypes-view', name: 'BP Types', desc: 'Business Partner Types', enabled: false },
            { profile: 'admin.brands-view', name: 'Brands', desc: 'Brand list', enabled: false },
            { profile: 'admin.country-view', name: 'Countries', desc: 'The Country list', enabled: true },
            { profile: 'admin.checklist-view', name: 'Program Checklists', desc: 'IOT-specific Checklists for each program', enabled: true },
            { profile: 'admin.users-view', name: 'User Profiles', desc: 'Profile for each user, controlling Countries, Programs etc', enabled: true },
            { profile: 'admin.columns-view', name: 'Search Table Columns', desc: 'Set the order of columns and their header names', enabled: false },
            { profile: 'admin.sampling-view', name: 'Sampling', desc: 'Manage sampling purposes', enabled: true },
            { profile: 'admin.validation-view', name: 'Validation Rule Tables', desc: 'Customising Validation Rules', enabled: true },
            { profile: 'admin.exchangerate-view', name: 'Exchange Rate Table', desc: 'Customising exchange rates', enabled: true },
            { profile: 'admin.calculation-view', name: 'Calculation Tables', desc: 'Customising uplifts and bonus rules', enabled: true },
            { profile: 'admin.adminreporting-view', name: 'Reporting Tables', desc: 'Customising reporting tables', enabled: true },
            { profile: 'admin.bpoiswitches-view', name: 'BPOI Switches', desc: 'Customising BPOI-switches', enabled: true },
            { profile: 'admin.approvedlist-view', name: 'Approved List', desc: 'New client approved list', enabled: true },
            { profile: 'admin.termsofuse-view', name: 'Acceptable Terms of Usage', desc: 'Acceptable Terms of Usage', enabled: true },
            { profile: 'admin.massupdates-view', name: 'Mass updates', desc: 'Performing mass updates. *WARNING* Use it carefully since it can corrupt the data', enabled: true },
            { profile: 'admin.complianceplan-view', name: 'Compliance Plan', desc: 'Compliance Plan - List of BPs', enabled: true },
            { profile: 'admin.mysaerrlogs-view', name: 'MySA Inbound Error Logs', desc: 'Review and resolve errors resulting from inbounds from MySA', enabled: true },
            { profile: 'admin.eslogs-view', name: 'Engage Support Update Logs', desc: 'Review and resolve errors resulting from updates to ES', enabled: true }
        ];
        this.socket.forward('admin.oppty_count', this.$scope);
        this.$scope.$on('socket:admin.oppty_count', function (event, data) {
            if (data.err) {
                _this.opptyCount = 'Could not retrieve opportunities count: ' + data.msg;
            }
            else {
                _this.opptyCount = data.dataUpdated;
                _this.countLoaded = true;
            }
        });
    }
    AdminMainController.prototype.$onInit = function () {
    };
    AdminMainController.prototype.getStats = function () {
        if (!this.countLoaded && !this.countFired) {
            this.countFired = true;
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'getAllOpptyCount',
                    script: 'admin/admin',
                    user: this.env.user
                }
            });
        }
    };
    AdminMainController.prototype.navigate = function (where) {
        this.$state.go(where, '');
    };
    AdminMainController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state', 'socket', '$scope', 'admin'];
    return AdminMainController;
}());
var AdminMainComponent = (function () {
    function AdminMainComponent() {
        this.templateUrl = 'admin-main.html';
        this.controllerAs = 'vm';
        this.controller = AdminMainController;
    }
    return AdminMainComponent;
}());
angular
    .module('application')
    .component('adminMainSection', new AdminMainComponent());

//# sourceMappingURL=admin.main.component.js.map
